import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Enregistrer le service worker pour activer la PWA
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // Nouvelle version disponible
    if (window.confirm('Une nouvelle version de l\'application est disponible. Voulez-vous la charger maintenant ?')) {
      registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    }
  },
  onSuccess: () => {
    console.log('Service Worker enregistré avec succès. L\'application peut fonctionner hors ligne.');
  }
});

